var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJmhz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 9.375,
    cy: 10.92,
    r: 1.441
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.616 6.172v8.699s.15 3.76-3.399 3.76-3.629-3.612-3.629-3.612M22.84 18.631V6.172h2.162l3.837 12.459 3.709-12.459h2.038v12.459"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M8.147 23.866v12.482M18.991 23.866v12.482M18.991 30.107H8.147M23.513 23.866h11.073L23.513 36.348h11.073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmhz);
export default __webpack_public_path__ + "static/media/JMHZ.61611a85ca0a6bf81c647f9edc69ef7d.svg";
export { ForwardRef as ReactComponent };